import { Box, Button, Tag, Text, Icon } from '@nimbus-ds/components';
import { Repeater } from 'commons/components';

function BulletSkeleton() {
  return (
    <Box display="flex" gap="1">
      <Icon.Skeleton />
      <Text.Skeleton width="100%" />
    </Box>
  );
}

export function Skeleton() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="2"
      alignSelf="stretch"
      minWidth="280px"
    >
      <Tag.Skeleton height="1rem" width="60px" />
      <Box display="flex" flexDirection="column" gap="1">
        <Text.Skeleton width="100px" />
        <Text.Skeleton width="100px" />
      </Box>
      <Box display="flex" flexDirection="column" gap="1" paddingTop="4">
        <Repeater times={5} item={BulletSkeleton} />
      </Box>
      <Box marginTop="4" display="flex" gap="2">
        <Button.Skeleton />
        <Button.Skeleton />
      </Box>
    </Box>
  );
}
